<div class="no-csp-support-info">
  <p>
    <mat-icon role="img" class="mat-icon notranslate explainer material-icons mat-ligature-font mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">
      info_outline
    </mat-icon>
    <span [innerHTML]="complianceText"></span>
    <a href="https://help.triggerbee.com/en/articles/13375815-triggerbee-and-content-security-policies-csp" target="_blank" rel="noopener noreferrer">
      @if (script) {
        {{ "campaign.widget.sidebar.layout.read-more" | translate }}
      } @else {
        <abbr title="Content Security Policy">{{ "campaign.widget.sidebar.layout.CSP" | translate }}</abbr>
      }
    </a>
  </p>
</div>
